import { Skeleton } from '@vesyl/ui'
import { Stack, type StackProps, Text } from '@vesyl/ui/chakra'
import { formatAddress, type FormatAddressData } from '../../lib/utils/format-address'

type AddressTextProps = {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'

  /**
   * Whether the address is loading
   */
  loading?: boolean

  address?: FormatAddressData | null
} & StackProps

export function AddressText(props: AddressTextProps) {
  const { size = 'md', address = null, loading = false, ...rest } = props

  if (!address && !loading) return null

  if (loading) {
    return (
      <Stack gap="2">
        <Skeleton h="4" maxW="40%" />
        <Skeleton h="4" maxW="50%" />
        {['md', 'lg'].includes(size) && <Skeleton h="4" maxW="60%" />}
        {['md', 'lg'].includes(size) && <Skeleton h="4" maxW="35%" />}
        {['lg'].includes(size) && <Skeleton h="4" maxW="80%" />}
      </Stack>
    )
  }

  if (!address) return null

  const rows = formatAddress(address, size).split('\n')

  return (
    <Stack as="address" {...rest}>
      {rows.map((row, index) => (
        <Text key={index} hidden={!row}>
          {row}
        </Text>
      ))}
    </Stack>
  )
}
